<div *ngIf="order && merchant">
    <app-receipt2 [order]="order" [merchant]="merchant" [brandname]="brandname" [isMerchant]="isMerchant"></app-receipt2>
</div>